<template>
  <div v-if="checkItems">
    <div class="row">
      <div class="col-md-12">
        <loading v-if="! showContent"></loading>
        <h2 class="titulo" v-if="showContent">{{ title }}</h2>
        <div class="blogs" v-if="showContent">
          <router-link class="noticia" :to="getUrl(item.id, item.title)" v-for="(item , index) in items" :key="index">
            <img v-if="item.image && showImage" :src="item.image"/>
            <h3 class="subtitle">{{ item.title }}</h3>
            <div class="data">
              <span>{{ item.date }}</span>
            </div>
            <div v-html="truncate(item.description)" v-if="item.description" class="texto"></div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../../helpers/api';
  import Loading from '../common/Loading.vue';
  import {slugify} from '../../helpers/slugify';

  export default {
    components: {
      Loading
    },
    props: [
      'bloco',
      'showImage'
    ],
    data() {
      return {
        items: [],
        showContent: true,
        title: 'Notícias'
      }
    },
    created() {
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }

      let self = this;
      // get('content/' + this.bloco.id).then(function (response) {
      //   self.items = response.data.result.data;
        self.items = this.$store.getters['getSiteContent'].result.data.noticia;
        // self.items = window.siteconfig.result.data.noticia;
        self.showContent = true;

      // });
    },
    methods: {
      getUrl(id, string) {
        return '/noticia/' + id + '/' + slugify(string);
      },
      truncate(source) {
        let size = 255;
        return source.length > size ? source.replace(/<\/?[^>]+(>|$)/g, "").slice(0, size - 1) + "…" : source;
      }
    },
    computed: {
      checkItems() {
        return this.items.length > 0;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/BlogList.vue